
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Holidaylist.css";
import HolidayListView from "../../../components/mobile/HolidayListView";

import MobileLayout from "../../../layouts/MobileLayout";

import { useAuthStore } from "../../../store/authStore";
import { api } from "../../../utils/api";


const Holidaylist = () => {

  const { user, isAuthenticated } = useAuthStore();
  const companyId = user?.company_id;
  const locationId = user?.location_id ?? user?.location;

  

  

  const [holidayData, setHolidayData] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();





useEffect(() => {
  setHolidayData([]);
  if (!companyId || !locationId || !isAuthenticated) {
    setLoading(false);
    return;
  }

  const controller = new AbortController();
  const fetchHolidays = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        `/holiday/list/${companyId}?location=${encodeURIComponent(locationId)}`,
        { signal: controller.signal },
      );

      const result = await response.json();
      if (controller.signal.aborted) return;

      if (!response.ok) {
        throw new Error(
          result.message || "Failed to load holidays"
        );
      }

      setHolidayData(Array.isArray(result) ? result : []);
    } catch (error) {
      if (controller.signal.aborted) return;
      console.error(error);
      setHolidayData([]);
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  };

  fetchHolidays();
  return () => controller.abort();
}, [companyId, locationId, isAuthenticated]);

  return (
    <MobileLayout>
      <HolidayListView
        holidays={holidayData}
        loading={loading}
        onBack={() => navigate(-1)}
      />
    </MobileLayout>
  );
};

export default Holidaylist;
